export function relocationValidate(relocation){
    var result = true;

    result = validateId(relocation.id);
    result = validateUuid(relocation.uuid);
    result = validateQuantity(relocation.quantity);
    result = validateOriginId(relocation.origin_id);
    result = validateDestinationId(relocation.destination_id);
    result = validateProductId(relocation.product_id);
    result = validateClientId(relocation.client_id);
    result = validateWarehouseId(relocation.warehouse_id);
    result = validatePalletOrigin(relocation.pallet_origin);
    result = validatePalletDestination(relocation.pallet_destination);
    result = validateBoxOrigin(relocation.box_origin);
    result = validateBatch(relocation.batch);
    result = validateReference(relocation.reference);
    result = validateUserId(relocation.user_id)

    return result;
}

function validateId(id){    
    if(Number.isInteger(id)) return true;
    else return false;
}

function validateUuid(uuid){    
    if(typeof uuid == "string") return true;
    else return false;
}

function validateQuantity(quantity){
    if(!isNaN(quantity) && quantity.toString().trim() !== "") return true;
    else return false;
}

function validateOriginId(origin_id){    
    if(Number.isInteger(origin_id)) return true;
    else return false;
}

function validateDestinationId(destination_id){    
    if(Number.isInteger(destination_id)) return true;
    else return false;
}

function validateProductId(product_id){    
    if(Number.isInteger(product_id)) return true;
    else return false;
}

function validateClientId(client_id){    
    if(Number.isInteger(client_id)) return true;
    else return false;
}

function validateWarehouseId(warehouse_id){    
    if(Number.isInteger(warehouse_id)) return true;
    else return false;
}

function validatePalletOrigin(pallet_origin) {
    if(!isNaN(pallet_origin) && pallet_origin.trim() !== "") return true;
    else return false;
}

function validatePalletDestination(pallet_destination) {
    if(!isNaN(pallet_destination) && pallet_destination.trim() !== "") return true;
    else return false;
}

function validateBoxOrigin(box_origin){
    if(!isNaN(box_origin) && box_origin.trim() !== "") return true;
    else return false;
}

function validateBatch(batch){
    if(typeof batch == "string") return true;
    else return false;
}

function validateReference(reference){
    if(typeof reference == "string") return true;
    else return false;
}

function validateUserId(user_id){    
    if(Number.isInteger(user_id)) return true;
    else return false;
}